import * as React from "react"
import styled from "styled-components"
import { Colors } from "theme"

const Svg = styled.svg`
  width: 28px;
  height: 28px;
  cursor: pointer;
  &:hover {
    path {
      fill: #161616;
    }
  }
`

const TwitterLogo = () => {
  return (
    <Svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1487 4.3757C17.2425 3.95822 18.4381 3.88674 19.5738 4.17092C20.477 4.3969 21.3077 4.83913 21.9963 5.45501C22.8433 5.14368 23.6467 4.72234 24.3856 4.20117L24.9867 5.05338L26 5.30015C25.6428 6.76701 24.9267 8.11905 23.9197 9.23641C23.9352 9.40474 23.9433 9.57375 23.9438 9.74297L23.9438 9.74642C23.9438 16.108 20.881 20.7751 16.4817 23.1166C12.1079 25.4446 6.51794 25.4188 1.53653 22.6514C1.11435 22.4168 0.908437 21.9231 1.03885 21.4581C1.16926 20.9931 1.60188 20.6785 2.08445 20.6977C3.84363 20.7676 5.58506 20.4178 7.16856 19.6883C5.60093 18.721 4.47235 17.5726 3.68771 16.3337C2.64103 14.681 2.2459 12.9303 2.17444 11.3581C2.10319 9.79052 2.3522 8.37907 2.61397 7.36691C2.74548 6.8584 2.88193 6.44409 2.98711 6.15315C3.03977 6.00751 3.08476 5.8923 3.11765 5.81113C3.13409 5.77053 3.14753 5.7384 3.1574 5.7152L3.16947 5.68712L3.17255 5.68007C3.17989 5.6632 3.18771 5.64646 3.196 5.62988L4.1288 6.09628L4.98226 5.49692C5.93707 6.85652 7.21331 7.95888 8.69731 8.70583C9.87771 9.29997 11.1604 9.65456 12.4717 9.75311C12.464 8.59584 12.8078 7.46316 13.4581 6.50516C14.1157 5.53651 15.0549 4.79318 16.1487 4.3757ZM4.5508 8.22755C4.35923 9.06329 4.20625 10.1231 4.25808 11.2634C4.31698 12.5592 4.63885 13.9372 5.44983 15.2177C6.2566 16.4915 7.58708 17.7321 9.76684 18.7009C10.1129 18.8547 10.3484 19.184 10.382 19.5612C10.4157 19.9383 10.2423 20.3041 9.929 20.5168C8.77041 21.3033 7.50173 21.8949 6.17298 22.2775C9.47913 23.1198 12.7921 22.7176 15.5017 21.2754C19.1846 19.3152 21.8575 15.3789 21.858 9.74816C21.8572 9.52279 21.8355 9.29798 21.7931 9.07662C21.7278 8.73469 21.8373 8.3827 22.0852 8.13826C22.3175 7.90915 22.5327 7.66496 22.7296 7.40772C22.4933 7.49486 22.2543 7.57488 22.0127 7.64762C21.6199 7.7659 21.1943 7.64293 20.9251 7.3334C20.4372 6.77241 19.7888 6.3748 19.0676 6.19433C18.3463 6.01387 17.5871 6.05926 16.8925 6.32438C16.1979 6.58949 15.6014 7.06153 15.1839 7.67666C14.7663 8.29179 14.5477 9.02032 14.5577 9.76372L14.5579 9.7777H14.5578V10.8206C14.5578 11.386 14.1071 11.8485 13.5419 11.8631C11.5372 11.9151 9.5508 11.4705 7.75955 10.5689C6.56484 9.96759 5.48169 9.17541 4.5508 8.22755Z"
        fill={Colors.secondaryGrey}
      />
    </Svg>
  )
}

export default TwitterLogo



// WEBPACK FOOTER //
// ./src/components/twitter/twitter-logo.tsx